import React from 'react';
import { TrendingUp, Users, Wrench, BarChart3 } from 'lucide-react';
import { Button } from './ui/button';
import { partnerData } from '../data/mock';

const iconMap = {
  'trending-up': TrendingUp,
  users: Users,
  wrench: Wrench,
  'bar-chart-3': BarChart3
};

const Partner = ({ onNavigate }) => {
  return (
    <section id="partner" className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-yellow-500/10 to-transparent" />
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-green-500/10 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-500 text-gray-900 px-6 py-2 rounded-full font-bold text-sm mb-6">
            PROGRAMME PARTENAIRE
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            {partnerData.title}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {partnerData.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {partnerData.benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div 
                key={index}
                className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-yellow-500/50 hover:bg-white/10 transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-yellow-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:bg-yellow-500 group-hover:scale-110 transition-all duration-300">
                  <Icon className="w-7 h-7 text-yellow-400 group-hover:text-gray-900 transition-colors duration-300" />
                </div>
                
                <h3 className="text-xl font-bold mb-3">
                  {benefit.title}
                </h3>
                
                <p className="text-gray-300 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Stats row */}
        <div className="grid md:grid-cols-3 gap-8 mb-16 max-w-4xl mx-auto">
          <div className="text-center p-6 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
            <div className="text-4xl font-bold text-yellow-400 mb-2">30%</div>
            <div className="text-gray-300">Commission sur le CA de votre secteur</div>
          </div>
          <div className="text-center p-6 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
            <div className="text-4xl font-bold text-green-400 mb-2">0€</div>
            <div className="text-gray-300">Frais d'installation</div>
          </div>
          <div className="text-center p-6 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
            <div className="text-4xl font-bold text-yellow-400 mb-2">48h</div>
            <div className="text-gray-300">Délai de réponse</div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button 
            size="lg"
            className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold text-lg px-10 py-6 rounded-xl shadow-2xl hover:shadow-yellow-500/50 transition-all duration-300 hover:scale-105"
            onClick={() => onNavigate('contact')}
          >
            Devenir Partenaire Maintenant
          </Button>
          <p className="text-gray-400 mt-6">
            Rejoignez les 50+ établissements partenaires qui génèrent des revenus passifs avec JYA
          </p>
          <p className="text-gray-300 mt-3 text-sm">
            💡 Besoin de plus de capacité ? Installez plusieurs bornes selon vos besoins
          </p>
        </div>
      </div>
    </section>
  );
};

export default Partner;
